import React, { Component } from "react";

import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import Button from '@material-ui/core/Button';

class ProductFilter extends Component {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.taskFilter = this.taskFilter.bind(this);
		this.langFilter = this.langFilter.bind(this);
		this.orderFilter = this.orderFilter.bind(this);
		this.handleChangeTask = this.handleChangeTask.bind(this);
		this.handleChangeOrder = this.handleChangeOrder.bind(this);
	}
	
	handleChange(e) {
		e.preventDefault();
		const {name, value} = e.target;
		let filter = this.props.productFilter;
		filter[name]=value;
		this.props.setProductFilter(filter);
	}

	handleSubmit(e) {

	}
	
	handleChangeTask(e){
		e.preventDefault();
		const {name, value} = e.target;
		let filter = this.props.productFilter;
		filter.taskFilter=value;
		this.props.setProductFilter(filter);
	}
	
	handleChangeOrder(e){
		e.preventDefault();
		const {name, value} = e.target;
		this.props.setOrderFilter(value);
	}
	
	taskFilter(){
		const productList = [];
			productList.push(<option value=''>ALL</option>);
			productList.push(<option value='translation'>TRANSLATORS</option>);
			productList.push(<option value='revision'>REVIEWERS</option>);
			productList.push(<option value='proof_print'>PROOF_PRINT</option>);
			productList.push(<option value='layout'>LAYOUT</option>);
			
			let roleSelect =<div style={{verticalAlign: "baseline"}}> 
							<span>Task: </span>
							<NativeSelect
								name="taskFilter"
								value={this.props.productFilter.taskFilter}
								onChange={this.handleChangeTask}>
									{productList}
							</NativeSelect>
							</div>
			return(roleSelect);
	}
	
	langFilter(st){
		var name;
		var description;
		if(st==="src"){
			name = "srcLangFilter";
			description = "Source Language: ";
		}else{
			name = "trgLangFilter";
			description = "Target Language: ";
		}

		let lang =<div style={{verticalAlign: "baseline"}}> 
					<span>{description}</span>
					<input type="text" id={description} name={name} minlength="2" maxlength="5" size="5" onChange={this.handleChange}/>
				</div>
		return(lang);
	}
	
	orderFilter(){
		const orderList = [];
			orderList.push(<option value='ALF'>Alfabetic</option>);
			orderList.push(<option value='RNK'>Ranking</option>);
			orderList.push(<option value='AVA'>Data Avaluació</option>);
			
			let orderSelect =<div style={{verticalAlign: "baseline"}}> 
							<span>Order: </span>
							<NativeSelect
								name="orderFilter"
								value={this.props.orderFilter}
								onChange={this.handleChangeOrder}>
									{orderList}
							</NativeSelect>
							</div>
			return(orderSelect);
	}
	
	render() {
		return (
		<div class="contentM">
			<form>
				<div class="row">
					<div class="col">{this.orderFilter()}</div>
					<div class="col">{this.taskFilter()}</div>
					<div class="col">{this.langFilter("src")}</div>
					<div class="col">{this.langFilter("trg")}</div>
				</div>
			</form>
		</div>
		);
	}
}

export default ProductFilter;